exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkout__accordion__title--done{opacity:.25;transition:opacity .2s ease-in-out}.checkout__accordion__title--done:hover{opacity:1;text-decoration:none}.checkout-summary{margin-bottom:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-335f81b5","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/Checkout/Wrapper.vue
// module id = EDXv
// module chunks = 116